module.exports = __webpack_public_path__ + "static/media/gryphon_musee_ids_ryspot_2.255943ec.jpg";